import { MSSQL_ENGINE } from "./sql-connection-engines";
import { createSqlConnectionForm } from "./sql-connection-form";

/** MS SQL Server. Everything but the engine spec lives in `sql-connection-form.tsx`. */
const createConnectionMssql = createSqlConnectionForm(MSSQL_ENGINE);
export { createConnectionMssql as CreateConnectionMssql };
